import { AxiosResponse } from 'axios';
import privateAxiosService from './privateAxiosService.ts';
import publicAxiosService, {
  getParamsWithDefOnes,
} from './publicAxiosService.ts';

const prefix = '/tournament';

// =================================
type GetTournamentLeaderboardAPIResponse = {
  board: Array<{
    id: number; // $place
    player_id: `0x${string}`;
    balance: number; // $total_amount
    price: number; // $price
  }>;
  start: number;
  end: number;
  next: number;
  max: number;
};

export const getTournamentLeaderboardAPI = async (params?: { fake: number }) =>
  publicAxiosService.get<undefined, GetTournamentLeaderboardAPIResponse>(
    `${prefix}/leaderboard`,
    {
      params: getParamsWithDefOnes(params),
    }
  );

// =================================
type GetCurrentTournamentAPIResponse =
  | {
      id: string;
      name: string;
      from: number;
      till: number;
      start_round: number;
      total_rounds: number;
    }
  | {
      error: 'No current tournament';
    };

export const getCurrentTournamentAPI = async () =>
  publicAxiosService.get<undefined, GetCurrentTournamentAPIResponse>(
    `${prefix}/current`,
    {
      params: getParamsWithDefOnes(),
    }
  );

// =================================
type GetActiveTournamentsAPIResponse = Array<{
  id: number;
  name: string;
  from: number;
  till: number;
  registered: number;
  max_users: number;
  total_rounds: number;
}>;

export const getActiveTournamentsAPI = async () =>
  publicAxiosService.get<undefined, GetActiveTournamentsAPIResponse>(
    `${prefix}/active`,
    {
      params: getParamsWithDefOnes(),
    }
  );

// =================================
type GetUserRegisteredTournamentsAPIResponse = {
  tournaments: Array<{
    tournament_id: number;
  }>;
};

export const getUserRegisteredTournamentsAPI = async () =>
  privateAxiosService.get<GetUserRegisteredTournamentsAPIResponse>(
    `${prefix}/registered`,
    {
      params: getParamsWithDefOnes(),
    }
  );

// =================================
export type PostTournamentRegisterUserAPIResponse = Array<'ok'>;

export type PostTournamentRegisterUserAPIParams = {
  tournament_id: number;
};

export const postTournamentRegisterUserAPI = async (
  params: PostTournamentRegisterUserAPIParams
) =>
  privateAxiosService.post<
    undefined,
    AxiosResponse<PostTournamentRegisterUserAPIResponse>,
    PostTournamentRegisterUserAPIParams
  >(`${prefix}/register`, params, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
